import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Output() menuToggle = new EventEmitter<void>();
  user: any;
  isHandset: boolean = false;
  opened: boolean = false;

  toggleSidenav() {
    this.menuToggle.emit();
  }
}
